import React, { useState } from 'react';
import './Signup.css';


const addUser = async (userData) => {

  let wsUrl = `${import.meta.env.VITE_REACT_APP_BACK_SPRING_USER_ENDPOINT}/users`;

  const role = {
    id: 1,
    roleName: "USER"
  };

  try {
    const response = await fetch(wsUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ ...userData, roles: [role] })
    });

    if (response.ok) {
      let data = await response.json();
      console.log("response data : " + JSON.stringify(data));

      // Redirection vers la page de tableau de bord
      window.location.href = '/';
    } else {
      let text = await response.text();
      console.log("error response text : " + text);
    }
  } catch (ex) {
    console.log("ex : " + ex);
  }
};

const UserAdd = () => {
  const [formData, setFormData] = useState({
    username: "",
    email_address: "",
    password: "",
    first_name: "",
    last_name: "",
    roles: ['USER']
  });

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    addUser(formData);
  };



  return (

    <>
      <div className="signup-section">
        <div className="form-box">
          <div className="form-value">
            <form onSubmit={handleSubmit}>
              <h2>Sign up</h2>
              <div className="inputbox">
                <input type="text" name="username" required value={formData.username} onChange={handleChange} />
                <label htmlFor="username">Username</label>
              </div>
              <div className="inputbox">
                <input type="text" name="email_address" required value={formData.email_address} onChange={handleChange} />
                <label htmlFor="email_address">Email</label>
              </div>
              <div className="inputbox">
                <input type="password" name="password" required value={formData.password} onChange={handleChange} />
                <label htmlFor="password">Password</label>
              </div>
              <div className="inputbox">
                <input type="text" name="first_name" required value={formData.first_name} onChange={handleChange} />
                <label htmlFor="first_name">First Name</label>
              </div>
              <div className="inputbox" >
                <input type="text" name="last_name" required value={formData.last_name} onChange={handleChange} />
                <label htmlFor="last_name">Last Name</label>
              </div>

              <button type="submit">Create</button>
              <div className="register">

              </div>
            </form>
          </div>
        </div>
      </div>
    </>

  );
}

export default UserAdd;